module.exports = __webpack_public_path__ + "img/genicon-judge-female.73032206.svg";